import {DspAdUnitBean, DspBean} from 'common/api/api'
import {MinusCircleOutlined, PlusOutlined} from '@ant-design/icons'
import {Button, Form, Input, InputNumber, Select} from 'antd'
import {useEffect, useState} from 'react'

const Option = Select.Option
const InputGroup = Input.Group

interface Props {
    dspAdUnitList: Array<DspAdUnitBean>
    setDspAdUnitList: (list: Array<DspAdUnitBean>) => void
    dspList: Array<DspBean>
}

const DspSelector = (props: Props) => {
    const [selectedDspAdUnitList, setSelectedDspAdUnitList] = useState<Array<DspAdUnitBean>>(
        props.dspAdUnitList,
    )
    const [filteredDsps, setFilteredDsps] = useState<any>([])

    useEffect(() => setSelectedDspAdUnitList(props.dspAdUnitList), [props.dspAdUnitList])

    useEffect(() => {
        //let temp = selectedDspAdUnitList.map((e) => e.dspId)
        //props.dspList?.filter((e) => !temp.includes(e.id as number))
        //setFilteredDsps(props.dspList?.filter((e) => !temp.includes(e.id as number)))
        setFilteredDsps(props.dspList)
    }, [selectedDspAdUnitList])

    const handleNewAdSizeBidFloor = () => {
        // @ts-ignore
        selectedDspAdUnitList.push({dspId: undefined, adUnit: undefined})
        setSelectedDspAdUnitList(selectedDspAdUnitList.slice())
    }

    const renderForm = () => {
        let formItems = selectedDspAdUnitList.map((item: DspAdUnitBean, index: number) => (
            <Form.Item className="multi-selector-center" wrapperCol={{span: 24, offset: 0}}>
                <InputGroup compact={true} style={{display: 'inline-block', marginRight: 8, width: 400}}>
                    <Select
                        style={{width: '60%'}}
                        placeholder="DSP"
                        value={item.dspId}
                        onChange={(dspId) => {
                            let bean = selectedDspAdUnitList[index]
                            bean.dspId = dspId
                            props.setDspAdUnitList(selectedDspAdUnitList.slice())
                        }}
                    >
                        {filteredDsps.map((adSize: DspBean) => (
                            <Option key={adSize.id} value={adSize.id as any}>
                                {adSize.name}
                            </Option>
                        ))}
                    </Select>
                    <InputNumber
                        placeholder="DSP Ad Unit ID"
                        value={item.adUnit}
                        style={{width: '40%'}}
                        step={1}
                        min={0}
                        max={100000}
                        onChange={(value) => {
                            const newList = selectedDspAdUnitList.map((listItem, idx) =>
                                idx === index ? {
                                    ...listItem,
                                    adUnit: value != null ? Number(value) : undefined
                                } : listItem,
                            )
                            props.setDspAdUnitList(newList)
                        }}
                    />
                </InputGroup>
                <MinusCircleOutlined
                    className="dynamic-delete-button"
                    type="minus-circle-o"
                    onClick={() => {
                        selectedDspAdUnitList.splice(index, 1)
                        props.setDspAdUnitList(selectedDspAdUnitList.slice())
                    }}
                />
            </Form.Item>
        ))

        return (
            <>
                {formItems}
                <Form.Item wrapperCol={{span: 24, offset: 0}}>
                    <Button
                        type="dashed"
                        onClick={() => handleNewAdSizeBidFloor()}
                        style={{width: 196, marginLeft: 4, marginRight: 22}}
                        disabled={filteredDsps.length === 0}
                    >
                        <PlusOutlined/>
                        Dsp
                    </Button>
                </Form.Item>
            </>
        )
    }

    return renderForm()
}

export default DspSelector
